module.exports = __webpack_public_path__ + "img/nocover.61a0b2b9.png";